<template>
  <or-layout>
    <a-row :gutter="[16, 16]" type="flex" justify="space-between">
      <a-col :span="24">
        <a-form layout="inline">
          <a-form-item>
            <a-input v-model="form.student_name" placeholder="学生名称" allowClear style="width: 100px;"></a-input>
          </a-form-item>
          <a-form-item>
            <a-input v-model="form.teacher_name" placeholder="招生老师" allowClear style="width: 100px;"></a-input>
          </a-form-item>

          <a-form-item>
            <a-select v-model="form.campus_name" placeholder="校区" allowClear style="width: 125px;"
                      :loading="loading" @change="searchbtn">
              <a-select-option value="老城小学部">老城小学部</a-select-option>
              <a-select-option value="雪峰小学部">雪峰小学部</a-select-option>
              <a-select-option value="南河小学部">南河小学部</a-select-option>
              <a-select-option value="公园小学部">公园小学部</a-select-option>
              <a-select-option value="宝轮小学部">宝轮小学部</a-select-option>
              <a-select-option value="东坝小学部">东坝小学部</a-select-option>
              <a-select-option value="万缘小学部">万缘小学部</a-select-option>
              <a-select-option value="南河中学部">南河中学部</a-select-option>
              <a-select-option value="东坝中学部">东坝中学部</a-select-option>
              <a-select-option value="老城中学部">老城中学部</a-select-option>
              <a-select-option value="万缘中学部">万缘中学部</a-select-option>
              <a-select-option value="总校">总校</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-model="form.grade_name" placeholder="年级" allowClear style="width: 90px;"
                      :loading="loading" @change="searchbtn">
              <a-select-option value="一年级">一年级</a-select-option>
              <a-select-option value="二年级">二年级</a-select-option>
              <a-select-option value="三年级">三年级</a-select-option>
              <a-select-option value="四年级">四年级</a-select-option>
              <a-select-option value="五年级">五年级</a-select-option>
              <a-select-option value="六年级">六年级</a-select-option>
              <a-select-option value="七年级">七年级</a-select-option>
              <a-select-option value="八年级">八年级</a-select-option>
              <a-select-option value="九年级">九年级</a-select-option>
              <a-select-option value="高一">高一</a-select-option>
              <a-select-option value="高二">高二</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item>
            <a-select v-model="form.subject_name" placeholder="学科" allowClear style="width: 75px;"
                      :loading="loading" @change="searchbtn">
              <a-select-option value="数学">数学</a-select-option>
              <a-select-option value="英语">英语</a-select-option>
              <a-select-option value="语文">语文</a-select-option>
              <a-select-option value="化学">化学</a-select-option>
              <a-select-option value="物理">物理</a-select-option>
              <a-select-option value="一科">一科</a-select-option>
              <a-select-option value="二科">二科</a-select-option>
              <a-select-option value="三科">三科</a-select-option>
              <a-select-option value="四科">四科</a-select-option>

            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-model="form.new_type" placeholder="新招类型" allowClear style="width: 160px;"
                      :loading="loading" @change="searchbtn">
                       <a-select-option value="2025寒假新招扩科">2025寒假新招扩科</a-select-option>
              <a-select-option value="2025秋季新招/扩科">2025秋季新招/扩科</a-select-option>
              
              <a-select-option value="30元课">30元课</a-select-option>
              <a-select-option value="扩科">扩科</a-select-option>
              <a-select-option value="新招">新招</a-select-option>
              <a-select-option value="小升初">小升初</a-select-option>
              <a-select-option value="初升高">初升高</a-select-option>
              <a-select-option value="寒假活动课">寒假活动课</a-select-option>
              <a-select-option value="3人成团享7折">3人成团享7折</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-model="form.pass_flag" placeholder="状态" allowClear style="width: 85px;"
                      :loading="loading" @change="searchbtn">
              <a-select-option value="-1">待审核</a-select-option>
              <a-select-option value="0">合格</a-select-option>
              <a-select-option value="1">不合格</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-range-picker @change="onDateChange" format="YYYY-MM-DD" :placeholder="['开始日期', '结束日期']"
                            style="width: 200px;"/>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" htmlType="submit" icon="search" @click="searchbtn"/>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" htmlType="submit" @click="exportData">导出</a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <div>
      <a-table :dataSource="testpaperList" :pagination="pageinfo" :loading="loading" max-width="1000"
               @change="onPaginationChange" rowKey="id">
        <a-table-column key="view_show" width="60px" title="试卷">
          <template slot-scope="item">
            <a @click="show_video(item.shijuan1,item.shijuan2,item.fujian1,item.fujian2)">查看</a>
          </template>
        </a-table-column>
        <a-table-column key="active" width="120px" title="操作">
          <template slot-scope="item">
            <a-button
                @click="edit_form.id=item.id;edit_form.pass_flag=item.pass_flag;edit_form.remarks=item.remarks;showAuditBox=true"
                class="active_btn" size="small" type="link">审核
            </a-button>
            <a-button @click="tableDel({ id: item.id,pass_flag:2})"
                      class="active_btn" size="small" type="link">删除
            </a-button>
          </template>
        </a-table-column>
        <a-table-column width="110px" data-index="beizhu" title="提交备注"></a-table-column>
        <a-table-column key="pass_flag" width="120px" title="状态">
          <template slot-scope="item">
            <span v-if="item.pass_flag===0">合格</span>
            <span v-if="item.pass_flag===1">不合格</span>
            <span v-if="item.pass_flag===-1">待审核</span>
          </template>
        </a-table-column>
        <a-table-column width="120px" data-index="remarks" title="审核备注"></a-table-column>
<!--        <a-table-column width="80px" data-index="id" title="序号"></a-table-column>-->
        <a-table-column width="120px" data-index="campus_name" title="校区名字"></a-table-column>
        <a-table-column width="100px" data-index="teacher_name" title="招生老师"></a-table-column>
        <a-table-column width="120px" data-index="dept_name" title="岗位名字"></a-table-column>
        <a-table-column width="100px" data-index="student_name" title="学生名称"></a-table-column>
        <a-table-column width="120px" data-index="student_mobile" title="学生电话"></a-table-column>
        <a-table-column width="100px" data-index="ah_school_name" title="就读校区"></a-table-column>
        <a-table-column width="100px" data-index="fenshu" title="入学分数"></a-table-column>
        <a-table-column width="100px" data-index="grade_name" title="年级名称"></a-table-column>
        <a-table-column width="100px" data-index="new_type" title="新招类型"></a-table-column>
        <a-table-column width="100px" data-index="subject_name" title="学科名称"></a-table-column>
        <a-table-column width="100px" data-index="pay_cost" title="缴费金额"></a-table-column>
        <a-table-column width="120px" data-index="pay_date" title="缴费日期"></a-table-column>
        <a-table-column width="110px" data-index="student_school_name" title="全日制学校"></a-table-column>
        <a-table-column width="110px" data-index="is_intro" title="是否转介绍"></a-table-column>
        <a-table-column width="110px" data-index="intro_name" title="转介绍名字"></a-table-column>

        <a-table-column width="160px" key="create_time" title="上传时间">
          <template slot-scope="item">
            {{ item.create_time }}
          </template>
        </a-table-column>

      </a-table>
    </div>
    <a-modal loading="loading" :destroyOnClose="true" :visible="showAuditBox" @ok="auditOkBtn"
             @cancel="showAuditBox = false" title="修改审核状态">
      <a-form>
        <a-form-item>
          <a-select placeholder="审核结果" v-model="edit_form.pass_flag" default-value="0">
            <a-select-option :value="-1">待审核</a-select-option>
            <a-select-option :value="0">合格</a-select-option>
            <a-select-option :value="1">不合格</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-input v-model="edit_form.remarks" placeholder="备注信息"/>
        </a-form-item>
      </a-form>
    </a-modal>
  </or-layout>
</template>

<script>
export default {
  data() {
    return {
      video_visible: false,
      media_path: "",
      showAuditBox: false,
      edit_form: {
        id: undefined,
        pass_flag: undefined,
        remarks: undefined
      },
      form: {
        teacher_name: undefined,
        subject_name: undefined,
        new_type: undefined,
        campus_name: undefined,
        grade_name: undefined,
        student_name: undefined,
        start_day: undefined,
        end_day: undefined,
        is_export: 0,
        pass_flag: undefined
      },
      subjectType: ['全部', '数学', '英语', '语文', '化学', '物理'],
      testpaperList: [],
      loading: false,
      gradeList: [],
      campusList: [],
      pageinfo: {
        showTotal: total => `共 ${this.pageinfo.total} 条`,
        showSizeChanger: true,
        total: 1,
        current: 1,
        pageSize: 10,
        allCnt: 0,
      },
    }
  },
  created() {
    this.getGrade()
    this.getCampusList()
    this.searchbtn()
  },

  methods: {
    onDateChange(value, dataStr) {
      if (value.length === 2) {
        let date = new Date(dataStr[0]);
        date.setHours(0, 0, 0, 0);
        let timestamp = date.getTime();
        this.form.start_day = timestamp / 1000;
        date = new Date(dataStr[1]);
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 1)
        timestamp = date.getTime();
        this.form.end_day = timestamp / 1000;
      } else {
        this.form.start_day = undefined;
        this.form.end_day = undefined;
      }
      this.searchbtn()
    },
    auditOkBtn() {
      if (this.edit_form.pass_flag !== 0 && this.edit_form.pass_flag !== 1) {
        this.$error({
          title: "错误",
          content: "审核结果只能为合格或者不合格",
          okText: "确定"
        });
        return false;
      }
      this.tableDel({id: this.edit_form.id, pass_flag: this.edit_form.pass_flag, remarks: this.edit_form.remarks});
    },
    show_video(img1, img2, img3, img4) {
      this.$viewerApi({
        images: [img1, img2, img3, img4],
      })
      // this.video_visible = true;
    },
    transitionTime(number) {
      if (!number) return '未提交'
      let time = new Date(Number(number) * 1000);
      let y = time.getFullYear();
      let m = time.getMonth() + 1;
      let d = time.getDate();
      return y + '年' + (m < 10 ? '0' + m : m) + '月' + (d < 10 ? '0' + m : m) + '日'
    },
    onPaginationChange(item) {
      this.pageinfo.pageSize = item.pageSize;
      this.pageinfo.current = item.current;
      this.searchbtn()
    },
    tableDel(data) {
      let _this = this;
      this.$axios
          .post("/api/Ksinfo/delete", {data})
          .then(res => {
            _this.showAuditBox = false;
            if (res.code !== 200) {
              _this.$error({
                title: "错误",
                content: res.msg,
                okText: "确定"
              });
            } else {
              _this.searchbtn();
            }
          })
          .catch(err => {
            _this.showAuditBox = false;
            console.error(err);
          });
    },
    async getCampusList() {
      try {
        let {code, data: {org_campus}, msg} = await this.$axios.post("/api/Admin/getorgsquadlist");
        if (code != 200) {
          this.$error({
            title: "错误",
            content: msg,
            okText: "确定"
          });
        } else {
          this.campusList = org_campus;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getGrade() {
      try {
        let {code, msg, data: {data}} = await this.$axios.post("/api/BasicGrade/index", {pageinfo: {pageSize: 100}});
        if (code != 200) {
          this.$error({
            title: "错误",
            content: msg,
            okText: "确定",
          });
        } else {
          this.gradeList = data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    exportData() {
      this.form.is_export = 1;
      this.$axios.post('/api/Ksinfo/getksinfolist', {
        data: this.form,
        pageinfo: this.pageinfo
      }).then(res => {
        this.loading = false;
        this.form.is_export = 0;
        if (res.code == 200) {
          window.open(res.data)
        }
      }).catch(error => {
        this.loading = false;
        this.form.is_export = 0;
      })
      this.loading = true;

    },
    async searchbtn() {
      this.loading = true;
      try {
        let {data: {data, pageinfo}} = await this.$axios.post('/api/Ksinfo/getksinfolist', {
          data: this.form,
          pageinfo: this.pageinfo
        });
        this.loading = false;
        this.testpaperList = data;
        this.pageinfo = pageinfo;
      } catch (error) {
        this.loading = false;
      }
    }
  }
}
</script>

<style lang="less" scoped></style>